/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Language_Switchtoenglishhelper3Inputs */

const en_language_switchtoenglishhelper3 = /** @type {(inputs: Language_Switchtoenglishhelper3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change the display language`)
};

const fr_language_switchtoenglishhelper3 = /** @type {(inputs: Language_Switchtoenglishhelper3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change the display language`)
};

/**
* | output |
* | --- |
* | "Change the display language" |
*
* @param {Language_Switchtoenglishhelper3Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const language_switchtoenglishhelper3 = /** @type {((inputs?: Language_Switchtoenglishhelper3Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Language_Switchtoenglishhelper3Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_language_switchtoenglishhelper3(inputs)
	return fr_language_switchtoenglishhelper3(inputs)
});
export { language_switchtoenglishhelper3 as "language_switchToEnglishHelper" }